"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var default_theme_1 = require("./default.theme");

exports.defaultTheme = default_theme_1.defaultTheme;